export default __webpack_public_path__ + "static/media/icon-big-calendar-88-px.c21779b3.svg";